import axios from 'axios'
const URL = process.env.REACT_APP_TYRION_URL

export const getSubscriptionAction = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/subscription`,
    })

    return res
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}
